<template lang="html">
  <el-tabs v-model="selectedTab">
    <el-tab-pane
      name="loginLog"
      label="操作紀錄"
      :lazy="true"
    >
      <OperationLog/>
    </el-tab-pane>
    <el-tab-pane
      name="access"
      label="最後操作"
      :lazy="true"
    >
      <LastAccess/>
    </el-tab-pane>
    <el-tab-pane
      name="sessions"
      label="目前 Session"
      :lazy="true"
    >
      <SessionList/>
    </el-tab-pane>
    <el-tab-pane
      name="sessionHistory"
      label="登入歷史"
      :lazy="true"
    >
      <SessionHistory/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import LastAccess from '@/components/Log/lastAccess.vue';
import OperationLog from '@/components/Log/OperationLog.vue';
import SessionList from '@/components/Log/SessionList.vue';
import SessionHistory from '@/components/Log/SessionHistory.vue';

export default {
  components: {
    LastAccess,
    OperationLog,
    SessionList,
    SessionHistory,
  },
  data() {
    return {
      selectedTab: 'loginLog',
    };
  },
  mounted() {
    console.log(this.selectedTab);
  },
};
</script>
